"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateConsents = exports.getConsentList = void 0;
/**
 * Fetches the consent list for the user.
 *
 * @param {string} cid - Customer ID from URL query parameters
 * @returns {Promise<Object>} - The JSON response containing consents.
 */
const getConsentList = async cid => {
  const response = await fetch('/multibrand/api/unsubscribe/get-consents', {
    method: 'GET',
    headers: {
      'X-Request-Context': cid,
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  });
  if (!response.ok) {
    throw new Error('Failed to fetch consent list.');
  }
  return await response.json();
};

/**
 * Updates the user consents.
 *
 * @param {string} cid - Customer ID from URL query parameters
 * @param {Object} payload - The payload with consents array.
 * @returns {Promise<Object>} - The JSON response after updating consents.
 */
exports.getConsentList = getConsentList;
const updateConsents = async (cid, payload) => {
  const response = await fetch('/multibrand/api/unsubscribe/change', {
    method: 'PUT',
    headers: {
      'X-Request-Context': cid,
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(payload)
  });
  if (!response.ok) {
    throw new Error('Server error: Unable to update consents at this time.');
  }
  return await response.json();
};
exports.updateConsents = updateConsents;